import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import PublicLayout from "../components/PublicLayout";

const PublicBlogs = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await axiosInstance.get("/all-blogs");
        setBlogs(response.data?.blogs || []);
      } catch (error) {
        console.error(error);
      }
    };

    load();
  }, []);

  return (
    <PublicLayout>
      <Helmet>
        <title>Career Insights and Guidance | YNB Jobs</title>
        <meta
          name="description"
          content="Expert career advice, hiring insights, and recruitment strategies from our content hub."
        />
      </Helmet>

      <section className="portal-hero border-bottom">
        <div className="portal-container">
          <div className="portal-hero-inner mb-0">
            <span className="portal-kicker">Resource Hub</span>
            <h1 className="portal-title mb-3">Career Knowledge and Advice</h1>
            <p className="portal-subtitle mx-auto">
              Practical guidance for job seekers and hiring teams from our expert-curated content engine.
            </p>
          </div>
        </div>
      </section>

      <section className="portal-section">
        <div className="portal-container">
          {blogs.length === 0 ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div className="mt-3 portal-muted">Loading insights...</div>
            </div>
          ) : (
            <div className="row gy-3">
              {blogs.map((blog) => (
                <div className="col-lg-4 col-md-6" key={blog.slug}>
                  <div className="portal-card p-3 h-100 d-flex flex-column">
                    <div className="text-primary small fw-bold mb-2">Category</div>
                    <h3 className="h6 fw-bold mb-2">{blog.title}</h3>
                    <p className="portal-muted small mb-3 flex-grow-1">
                      Actionable advice to strengthen your career path and stay informed on hiring trends.
                    </p>
                    <div className="d-flex justify-content-between align-items-center mt-auto pt-2 border-top">
                      <span className="portal-muted small">
                        {blog.createdAt
                          ? new Date(blog.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
                          : "Latest"}
                      </span>
                      <Link to={`/blogs/${blog.slug}`} className="text-primary fw-bold text-decoration-none">
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="portal-section-subtle border-top">
        <div className="portal-container">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              <h2 className="h4 fw-bold mb-2">Subscribe for Insights</h2>
              <p className="portal-muted mb-3 small">Get expert hiring and career advice in your inbox each week.</p>
              <div className="d-flex flex-column flex-sm-row gap-2">
                <input className="portal-input" placeholder="Professional email address" />
                <button className="portal-btn-primary border-0 px-4">Join Hub</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
};

export default PublicBlogs;
